import { Feedback } from "domain/entities/ai-search.entities";
import { createAppAsyncThunk } from "domain/store.thunk";
import { ToastStep } from "domain/ai-search/ai-search.slice";

export const openAIFeedbackToast = createAppAsyncThunk(
  "aiSearch/openAIFeedbackToast",
  async (_, { extra: { aiSearchGateway } }) => {
    return true;
  }
);

export const closeAIFeedbackToast = createAppAsyncThunk(
  "aiSearch/closeAIFeedbackToast",
  async (_, { extra: { aiSearchGateway } }) => {
    return true;
  }
);

export const setTechniqueFeedbackValue = createAppAsyncThunk(
  "aiSearch/setTechniqueFeedbackValue",
  async (feedbackValue: Partial<Feedback>, { extra: { aiSearchGateway } }) => {
    return feedbackValue;
  }
);

export const clearTechniqueFeedbackValues = createAppAsyncThunk(
  "aiSearch/clearTechniqueFeedbackValues",
  async (_, { extra: { aiSearchGateway } }) => {
    return true;
  }
);

export const sendAIFeedback = createAppAsyncThunk(
  "aiSearch/sendAIFeedback",
  async (reason: string, { extra: { aiSearchGateway }, getState }) => {
    const feedback = getState().aiSearch.techniqueFeedback;
    return await aiSearchGateway.sendAIFeedback({
      ...feedback,
      reason,
      innizRefs: getState().aiSearch.techniqueAISearchResults,
    });
  }
);

export const setAIToastStep = createAppAsyncThunk(
  "aiSearch/setAIToastStep",
  async (step: ToastStep, { extra: { aiSearchGateway } }) => {
    return { step };
  }
);

export const getTechniquesByAISearch = createAppAsyncThunk(
  "aiSearch/getTechniquesByAISearch",
  async (
    body: { search: string; limit?: number },
    { extra: { aiSearchGateway } }
  ) => {
    return await aiSearchGateway.getTechniquesByAISearch(body);
  }
);
